import { useActiveConversationData } from 'hooks/useActiveConversationData'
import { useStreamingReferences } from 'stores/useStreamingReferencesStore'

import { isMessageProcessing } from 'utils/isMessageProcessing'

export const useReferenceByMessageIdAndReferenceId = (messageId?: string, referenceId?: string) => {
  const { activeConversationData } = useActiveConversationData()

  const message = activeConversationData?.messages.find(
    conversationMessage => conversationMessage.id === messageId,
  )

  const streamingReferences = useStreamingReferences(messageId)

  if (!message) {
    return undefined
  }

  if (message.status === 'success') {
    return message?.references.find(reference => reference.refId === referenceId)
  }

  if (isMessageProcessing(message)) {
    return streamingReferences.find(reference => reference.refId === referenceId)
  }

  return undefined
}
